import { useState } from 'react';

export const CodeApi3 = () => {
  const [pValue] = useState(20);
  const [sValue] = useState(12);

  return (
    <div>
      <code>{"import React, { useState, useEffect } from 'react';"}</code>
      <br />
      <code>{"import useApi from './useApi';"}</code>
      <br />
      <br />
      <code>{'const TaskList = () => {'}</code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>
        {"const { data: tasks, loading, error } = useApi('https://api.example.com/tasks');"}
      </code><br/><br/>
      <code style={{ paddingLeft: `${pValue}px` }}>
        {'if (loading) return <p>Loading tasks...</p>;'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>
        {'if (error) return <p>Error loading tasks: {error.message}</p>;'}
      </code>
      <br />
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>{'return ('}</code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue}px` }}>{'<ul>'}</code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'{tasks.map(task => ('}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue + pValue}px` }}>
        {'<li key={task.id}>{task.title}</li>'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue + pValue}px` }}>
        {'))}'}
      </code>
      <br />
      <code style={{ paddingLeft: `${pValue + pValue}px` }}>{'</ul>'}</code>
      <br />
      <code style={{ paddingLeft: `${pValue}px` }}>{');'}</code>
      <br />
      <code>{'};'}</code>
      <br />
      <br />
      <code>{'export default TaskList;'}</code>
    </div>
  );
};
